export const FieldType = {
  text: 'text',
  number: 'number',
  password: 'password',
  link: 'link'
}

export const Settings = {
  appSettings: {
    id: 'appSettings',
    fields: [
      {
        id: 'APP_TOS_URL',
        name: 'App TOS URL',
        type: FieldType.link,
        gridColumn: {
          xs: 12
        }
      },
      {
        id: 'aboutUsURL',
        name: 'About Us URL',
        type: FieldType.link,
        gridColumn: {
          xs: 12
        }
      },
      {
        id: 'appLogoURL',
        name: 'App logo URL',
        type: FieldType.link,
        gridColumn: {
          xs: 12
        }
      }
    ]
  },
  emailSettings: {
    id: 'emailSettings',
    label: 'Email Settings',
    fields: [
      {
        id: 'senderEmail',
        name: 'Sender Email',
        type: FieldType.text,
        gridColumn: {
          xs: 12,
          md: 6
        }
      },
      {
        id: 'smtpServer',
        name: 'SMTP Sever',
        type: FieldType.text,
        gridColumn: {
          xs: 12,
          md: 6
        }
      },
      {
        id: 'password',
        name: 'Password',
        type: FieldType.password,
        gridColumn: {
          xs: 12
        }
      }
    ]
  },
  googleRecaptcha: {
    id: 'googleRecaptcha',
    label: 'Google Recaptcha',
    fields: [
      {
        id: 'recaptchaSecretKey',
        name: 'Google Recaptcha Secret Key',
        type: FieldType.password,
        gridColumn: {
          xs: 12,
          md: 12
        }
      }
    ]
  },
  groqApi: {
    id: 'groqApi',
    label: 'AI Bio Summarization',
    fields: [
      {
        id: 'groqApiKey',
        name: 'GROQ API Key',
        type: FieldType.password,
        gridColumn: {
          xs: 12,
          md: 12
        }
      }
    ]
  }
}

export const TemplateNames = {
  welcomeEmail: {
    id: 'welcomeEmail',
    name: 'Conference Admin Welcome Email Template',
    subjectKey: 'confAdminWelcomeEmailSubject',
    bodyKey: 'confAdminWelcomeEmailBody'
  }
}
